import React, { useState } from 'react';
import Landing from './components/Landing';
import HowTo from './components/HowTo';
import Contact from './components/Contact';
import Home from './components/Home';
import NewGame from './components/NewGame';
import UmpireView from './components/UmpireView';
import JoinGame from './components/JoinGame';
import SpectatorView from './components/SpectatorView';
import './App.css';

export default function App() {
  const [screen, setScreen] = useState('landing');
  const [gameData, setGameData] = useState(null);

  const navigate = (to, data = null) => {
    setGameData(data);
    setScreen(to);
    window.scrollTo(0, 0);
  };

  return (
    <div className="app">
      {screen === 'landing' && <Landing navigate={navigate} />}
      {screen === 'howto' && <HowTo navigate={navigate} />}
      {screen === 'contact' && <Contact navigate={navigate} />}
      {screen === 'app' && <Home navigate={navigate} />}
      {screen === 'home' && <Home navigate={navigate} />}
      {screen === 'newGame' && <NewGame navigate={navigate} />}
      {screen === 'umpire' && <UmpireView game={gameData} navigate={navigate} />}
      {screen === 'join' && <JoinGame navigate={navigate} />}
      {screen === 'spectator' && <SpectatorView game={gameData} navigate={navigate} />}
    </div>
  );
}
